import { Button } from "components/atoms/button/button";
import styled from "styled-components";

export const PastClassModalTopicsContainer = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const PastClassModalHeading = styled.h3`
  margin: 16px 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.3;
`;

export const PastClassDetailHeading = styled.h3`
  margin: 16px 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.3;
`;

export const PastClassDetailMetaBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 30px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[100]};
`;

export const PastClassDetailBlock = styled.div``;

export const PastClassDetailTeacherName = styled.p`
  margin: 0 0 4px 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
  display: flex;
  align-items: center;
`;

export const PastClassDetailInfoItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const PastClassDetailInfoItem = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ theme }) => theme.colors.neutral[600]};
  margin: 0;
  &:not(:last-child) {
    &:after {
      content: "•";
      margin: 0 4px;
      font-size: ${({ theme }) => theme.fontSizes["md"]};
      color: ${({ theme }) => theme.colors.neutral[600]};
    }
  }
`;

export const PastClassDetailMaterialBlock = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 50px;
`;
export const PastClassDetailMaterialItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PastClassDetailMaterialTitle = styled.h4`
  margin: 16px 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1;
`;

export const PastClassDetailVideoThumbnailIcon = styled.div<{
  canAccessStudyMaterial: boolean;
}>`
  color: ${({ theme }) => theme.colors.brand[500]};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: ${({ canAccessStudyMaterial }) => canAccessStudyMaterial && "0.8"};
  transition: 0.3s ease;
`;

export const LockIconWrapper = styled.div`
  border-radius: 50%;
  width: 58px;
  height: 58px;
  background-color: ${({ theme }) => theme.colors.neutral[100]};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PastClassDetailVideoThumbnailWrapper = styled.figure<{
  canAccessStudyMaterial: boolean;
}>`
  margin: 0;
  position: relative;
  padding: 56.65% 0 0 0;
  cursor: pointer;
  &:hover {
    ${PastClassDetailVideoThumbnailIcon} {
      opacity: 1;
    }
  }
`;
export const PastClassDetailVideoThumbnail = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  object-fit: cover;
`;

export const PastClassDetailsStudyMaterialCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 16px;
  display: grid;
  grid-template-columns: 76px 1fr 130px;
  grid-gap: 16px;
  border-radius: 8px;
  box-shadow: 0px 0px 32px ${({ theme }) => theme.colors.transparent.white10};
`;

export const PastClassDetailStudyMaterialCardIcon = styled.div`
  padding: 16px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.brand[100]};
  color: ${({ theme }) => theme.colors.brand[300]};
`;

export const PastClassDetailStudyMaterialCardTitle = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.3;
  word-break: break-word;
`;

export const PastClassDetailStudyMaterialDownloadLink = styled(Button)`
  padding: 10px 16px !important;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.brand[500]};
  color: ${({ theme }) => theme.colors.white};
  align-self: flex-end;
  border: none;
  cursor: pointer;
  display: flex;
  gap: 10px;
`;

export const PastClassDetailsStudyMaterialContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PastClassDetailVideoBlock = styled.div``;

export const PastClassDetailVideoBlockBackButton = styled.button`
  appearance: none;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.colors.brand[500]};
  background: none;
  border: none;
`;

export const PastClassDetailVideoBlockTitle = styled.h3`
  margin: 12px 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1;
`;

export const PastClassDetailVideoBlockWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.65%;
  margin: 16px 0;
`;

export const PastClassDetailAttendance = styled.div<{ classAttended: boolean }>`
  color: ${({ theme, classAttended }) =>
    classAttended ? theme.colors.green[600] : theme.colors.neutral[600]};
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: bold;
  line-height: 1;
`;

export const PastClassDetailAttendanceMessage = styled.p`
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 1;
`;

export const PastClassDetailDescriptionBlock = styled.div`
  margin: 0;
  background: ${({ theme }) => theme.colors.green[100]};
  padding: 0 16px 16px 16px;
  border-radius: 8px;
  overflow: hidden;
`;

export const PastClassDetailDescriptionBlockHeading = styled.h4`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
`;

export const PastClassDetailDescriptionBlockDesc = styled.div`
  /* Need to direct target html elements as we are getting html from BE */
  p {
    margin: 0;
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: ${({ theme }) => theme.fontSizes.md};
    color: currentColor;
  }
  color: ${({ theme }) => theme.colors.neutral[600]};
`;
